import AddressCard from './AddressCard.vue';

export default AddressCard;
